'use strict';

var React = require('react');
var ReactDom = require('react-dom');
var appTypes = require('../../types/appTypes');
var convertHelper = require('../../types/convertHelper');
var styleHelper = require('../../helper/styleHelper');
var _ = require('underscore');
var tool = require('../../helper/tool');
var GlobalConst = require('../../types/GlobalConst');
var util = require('../../helper/util');
var measureTextHelper = require('../../helper/measureHelper');

var TextParts = React.createClass({

  propTypes: {
    partStyle: React.PropTypes.object,
    showText: React.PropTypes.string
  },

  textStyle: function () {
    var style = styleHelper.builderTextStyle(this.props);
    var textHeight = measureTextHelper.measureTextWidth(style,'YMK').height;

    this.offset = Math.floor((lineHeight - textHeight)/2);
    //this.offset = Math.floor((lineHeight - textHeight)/(this.props.lineSpacingMultiple||1));
    //console.log('fontFamily=',style.fontFamily,'\nfontSize=',style.fontSize,'\ntextHeight=',textHeight,'\nlineHeight=',lineHeight,'\noffsetTop=',this.offset);
    var textStyle = _.extend(style, {
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      position: 'relative',
      wordWrap: this.props.textWordWrap ? 'break-word' : 'nowrap',
      wordBreak: 'break-word',
      boxSizing: 'border-box',
      zIndex: this.props.zIndex || 10
    });

    // 原来的老版本数据，有些没有 lineHeight，导致取出来为0，这时不能去设置为 0
    var lineHeight = styleHelper.builderLineHeight(this.props);
    if (lineHeight) {
      textStyle.lineHeight = lineHeight + 'px';
    } else {
      textStyle.lineHeight = '1em';
    }
    return tool.extendObj(textStyle, this.props.partStyle);
  },

  render: function () {
    var textArray;
    var divStyle;
    var labelStyle;
    var pStyle;
    var divMultiStyle;
    var showText;
    var i;
    var w ;
    var scale = 1;
    var usePtag = this.props.textWordWrap;
    var fontSize = styleHelper.getFontSize(this.props);
    if (_.isUndefined(usePtag)) {
      usePtag = false;
    }
    if(this.props.partStyle && this.props.partStyle){
      w = this.props.partStyle.width;
    }
    if(!w){
      w = styleHelper.getWidth(this.props);
    }
    showText = styleHelper.getText(this.props);
    showText = util.Text.removeLastEmptyRow(showText);
    textArray = util.Text.delimitText(showText, util.Text.DM_RETURN);
    this.isMultiLineText = textArray.length > 1;
    if (this.isMultiLineText) {
      for (i = 0; i < textArray.length; i++) {
        textArray[i] = util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(textArray[i]));
      }
      usePtag = true;
    } else {
      showText = util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(showText));
      if (textArray.length)
        textArray[0] = showText;
    }

    divStyle = this.textStyle();

    labelStyle = convertHelper.getTextAlign(this.props.textAlign, this.props.textVAlign);
    labelStyle = _.extend(labelStyle, {
      width: '100%',
      textAlign: convertHelper.getTextHorizontalAlign(this.props.textAlign),
      whiteSpace: !this.props.textWordWrap ? 'nowrap' : 'normal',
      wordBreak: 'normal',
      wordWrap: 'break-word',
      textDecoration: this.props.textStyles ? this.props.textStyles.textDecoration : 'normal',
    });

    if (fontSize < 12) {
      scale = fontSize / 12;
      w = w / scale;
    }

    pStyle = {
      margin: '0',
      padding: 0,
      width: w,
      transform: 'scale(' + scale + ')',
      transformOrigin: 'top left',
      textOverflow: 'clip',
      whiteSpace: !this.props.textWordWrap ? 'nowrap' : 'normal',
      textAlign: convertHelper.getTextHorizontalAlign(this.props.textAlign),
      textDecoration: this.props.textStyles ? this.props.textStyles.textDecoration : 'normal',
      userSelect: 'text',

    };

    divMultiStyle = styleHelper.StyleUtil(this.props).align().default({
      left: 0,
      width: w,
      overflow:'hidden',
      position: 'absolute'
    }).style;//  convertHelper.builderTextAlign(this.props.textAlign, this.props.textVAlign);

    if (usePtag) {
      divMultiStyle.lineHeight = 'inherit';
    }

    var valign = this.props.textVAlign;
    switch (valign) {
    case appTypes.VertAlign.TOP:
      divMultiStyle.top = 0;
      break;
    case appTypes.VertAlign.MIDDLE:
      divMultiStyle.top = '50%';
      divMultiStyle.transform = 'translateY(-50%)';
      break;
    case appTypes.VertAlign.BOTTOM:
      divMultiStyle.bottom = 0;
      break;
    }

    return (<div style={divStyle}>
      {
        !usePtag
          ?
          <label ref="lab" style={labelStyle}>{showText}</label>
          :
          <div ref="p" style={divMultiStyle}>
            {
              textArray.map(function (text, idx) {
                if (text.trim()) {
                  return (<p key={idx} style={pStyle}>
                    <span>{text}</span>
                  </p>);
                }
                return (<br key={idx}/>);
              }, this)
            }
          </div>
      }
    </div>);
  },

  splitSpace: function(text) {
    return text.trim().split(' ');
  },
});

module.exports = TextParts;




// WEBPACK FOOTER //
// ./src/views/common/TextParts.jsx